import { required, resolveNopeRefs } from './shared';
import type { FieldError, NopeContext, ObjectShape, ValidationRule } from './shared';

const min =
  (minNumber: number, message: string): ValidationRule =>
  (value, context) => {
    const resolvedValue = resolveNopeRefs(value, context) as number;

    return resolvedValue <= minNumber && message;
  };

const max =
  (maxNumber: number, message: string): ValidationRule =>
  (value, context) => {
    const resolvedValue = resolveNopeRefs(value, context) as number;

    return resolvedValue >= maxNumber && message;
  };

const includes =
  (options: unknown[], message: string): ValidationRule =>
  (value, context) => {
    const resolvedOptions = resolveNopeRefs(options, context) as unknown[];
    const resolvedValue = resolveNopeRefs(value, context);

    return !resolvedOptions.includes(resolvedValue) && message;
  };

class NopeNumber {
  validationRules: ValidationRule[] = [];

  required(message = 'This field is required'): this {
    this.validationRules.push(required(message));

    return this;
  }

  max(length: number, message = `Input can't be longer than ${length} characters`): this {
    this.validationRules.push(max(length, message));

    return this;
  }

  min(length: number, message = `Input can't be shorter than ${length} characters`): this {
    this.validationRules.push(min(length, message));

    return this;
  }

  oneOf(options: unknown[], message = `Input must be one of ${options.join(', ')}`): this {
    this.validationRules.push(includes(options, message));

    return this;
  }

  validate(entry: unknown, context?: NopeContext, objectShape?: ObjectShape): FieldError {
    for (const fn of this.validationRules) {
      const error = fn(entry, context, objectShape);

      if (error) {
        return error;
      }
    }
  }
}

export default NopeNumber;
